export const LEADS_LANGUAGE = {
  leads_add_information: "Information",
  leads_add_name: "Name",
  leads_add_name_err: "Name is required field",
  leads_add_name_limit_err: "Character must be smaller then 50",
  lead_add_email_label: "Email",
  lead_add_email_error: "Email is required field",
  lead_add_email_validation: "Email should be a valid email",
  leads_add_contact_label: "Contact Number",
  leads_add_contact_error_msg: "Contact Number is required field",
  leads_add_assign_to_label: "Assign to",
  leads_add_assign_to_error: "Assign to is required field",

  leads_info_text: "Information",
  leads_view_name: "Lead Name",
  leads_name: "Name",
  leads_contact_number: "Contact Number",
  leads_converted_on: "Converted on",
  leads_created_at: "Created At",
  leads_email: "Email",
  leads_assign_to: "Assign to",
  leads_date: "Date",
  leads_view_status: "Status",
  leads_view_top_bar_search: "Search",
  leads_view_line_of_business: "Line of Business",
  leads_view_list: "Leads List",
  leads_health_listing_heading: "Leads Management",
  leads_view_action: "Actions",

  leads_auto_email: "Email Address",
  leads_auto_listing_heading: "Leads Management",
  leads_auto_name: "Name",
  leads_auto_contact_number: "Contact Number",
  leads_auto_created_at: "Created At",
  leads_auto_quote_id: "Quote Id",
  leads_auto_partner_name: "Partner Name",
  leads_auto_dealership_name: "Dealership Name",
  leads_auto_sale_point: "Sale Point",
  leads_auto_car_make: "Car Make",
  leads_auto_car_model: "Car Model",
  leads_auto_year: "Year",
  leads_auto_car_value: "Car Value (Rs)",
  leads_auto_converted_on: "Converted On",
  leads_auto_created_by: "Created By",
  leads_auto_last_updated: "Last Updated",
  leads_auto_export_to_excel: "Export to Excel"
};
